import React from 'react';
import './OTSModal.scss';
function CustomModal({ children }) {
    return (
        <div className='ots-modal'>
            <div className='ots-modal-content'>{children}</div>
        </div>
    );
}

export default CustomModal;